<template>

  <el-main class="main_content_detail" style="padding: 20px">
    <div class="cont_navs_header1222">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/orderListNew')">新活动订单管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>新活动订单详情</a>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <!-- <div style="width:100px">
        <el-button type="text" icon="el-icon-printer">打印</el-button>
      </div> -->
    </div>

    <div class="contain_div2222">

      <div class="contain_header clr">
        <div class="userInfooi">
          <div class="moreUserInfo11">
            <div class="base_label">基本信息</div>
            <ul>
              <li>
                <font class="colorC fontWidth">订单号：</font>{{ orderDetail.orderCode }}
              </li>
              <li>
                <font class="colorC fontWidth">代理姓名：</font>{{ username }}
              </li>

              <li>
                <font class="colorC fontWidth">代理手机号：</font>{{ telephone }}
              </li>
              <li>
                <font class="colorC fontWidth">订单总金额：</font>{{ orderDetail.totalMoney }}
              </li>

              <li>
                <font class="colorC fontWidth">下单时间：</font>{{ orderDetail.createTime }}
              </li>

              <li style="width:100%">
                <font class="colorC fontWidth">订单备注：</font>{{ orderDetail.remark }}
              </li>

              <li style="width:50%">
                <font class="colorC fontWidth">地址：</font>
                {{ orderDetail.receivingProvince }}{{ orderDetail.receivingCity }}{{ orderDetail.receivingDistrict }}-{{
                    orderDetail.receivingAddressDetail
                }}:{{ orderDetail.receivingUsername
}}({{ orderDetail.receivingTelephone }})
              </li>

              <li>
                <font class="colorC fontWidth">发货人：</font>{{ $route.query.sendName }}
              </li>

              <li>
                <font class="colorC fontWidth">发货时间：</font>{{ orderDetail.sendTime }}
              </li>
              <li>
                <font class="colorC fontWidth">是否打印:</font>
                <span v-if="orderDetail.printStatus == 1">未打印</span>
                <span v-else-if="orderDetail.printStatus == 2">已打印</span>
                <span v-else>未打印</span>
              </li>

              <li style="width:20%">
                <font class="colorC fontWidth">物流号：</font>{{ orderDetail.postageCode }}
              </li>

              <!-- <el-button style="margin-left:15px" @click="print()" type="primary" size="small">打印</el-button> -->
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="contain_body_head" v-if="subs.length > 0">
        已发货列表
      </div>
      <div v-for="(item, index) in orderDetail.subPackage" :index="index" v-if="orderDetail.subPackage.length > 0">
        <el-card style="margin-top: 10px" shadow="never">
          <div>物流单号：{{ item.postageCode }}</div>
          <div>代理人：{{ item.username }}</div>
          <div>发货人：{{ item.sendUsername }}</div>
        </el-card>
        <el-table show-summary v-loading="subListLoading" :data="item.sendGoodList" style="width: 100%"
          :header-cell-class-name='objectSpanMethod'>
          <el-table-column prop="goodMsg" label="商品名称">
            <template slot-scope="scope">
              {{ scope.row.goodMsg.good_name }}
            </template>
          </el-table-column>
          <el-table-column prop="goodMsg" label="商品价格">
            <template slot-scope="scope">
              {{ scope.row.goodMsg.proxy_price }}
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量">
          </el-table-column>

           <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.list_pic"
                style="width:50px;"
              >
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div style="height:10px;width:10px"></div>
      <div class="contain_body_head" v-if="orderDetail.subPackage.length > 0">
        未发货列表
      </div>
      <div v-if="orderDetail.subPackage.length > 0">
        <el-table show-summary v-loading="subListLoading" :data="orderDetail.subPackage[0].noSendGoodList"
          style="width: 100%" :header-cell-class-name='objectSpanMethod'>
          <el-table-column prop="goodMsg" label="商品名称">
            <template slot-scope="scope">
              {{ scope.row.goodMsg.good_name }}
            </template>
          </el-table-column>
          <el-table-column prop="goodMsg" label="商品价格">
            <template slot-scope="scope">
              {{ scope.row.goodMsg.proxy_price }}
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量">
          </el-table-column>

           <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img
                :src="scope.row.list_pic"
                style="width:50px;"
              >
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div style="height:10px;width:10px"></div> -->

      <div class="contain_body_head" v-if="buList.length > 0">
        商品列表
      </div>
      <el-table show-summary v-loading="subListLoading" :data="subList" style="width: 100%"
        :header-cell-class-name='objectSpanMethod'>

        <el-table-column prop="goodName" label="商品名称">
        </el-table-column>

        <el-table-column label="商品图片">
          <template slot-scope="scope">
            <img :src="scope.row.listPic" style="width:50px;height: 50px;">
          </template>
        </el-table-column>

        <el-table-column prop="proxyPrice" label="代理价">
        </el-table-column>

        <el-table-column prop="num" label="购买数量">
        </el-table-column>

        <el-table-column prop="totalMoney" label="总价">
        </el-table-column>

      </el-table>
      <div style="height:10px;width:10px"></div>
 
    </div>
  </el-main>
</template>


<script>
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";

export default {
  name: "orderDetailNew",
  created() {
    var orderId = this.$route.query.orderId;
    console.info(orderId);
    let that = this;
    that.orderId = orderId;
    that.subListVisible = true;
    that.subListLoading = true;
    let para = {
      token: localStorage.getItem("api_token"),
      orderId: orderId,
    };
    // console.log(that.orderDetail);
    API.h5_good_order_detail(para)
      .then(
        function (result) {
          that.subListLoading = false;
          if (result && parseInt(result.key) == 1000) {
            that.username = result.result.map.username;
            that.telephone = result.result.map.telephone;
            that.orderDetail = result.result.map.order;
            if (that.orderDetail.createTime != null) {
              that.orderDetail.createTime = dateFunc.formatDate(
                new Date(parseInt(result.result.map.order.createTime)),
                "yyyy-MM-dd hh:mm:ss"
              );
            }
            if(that.orderDetail.sendTime != null){
            that.orderDetail.sendTime = dateFunc.formatDate(
                new Date(parseInt(result.result.map.order.sendTime)),
                "yyyy-MM-dd hh:mm:ss"
              );
            }

            
            that.subList = result.result.map.subs;
            // console.log(that.subList);
            // if(result.result.map.subPackage && result.result.map.order.length > 0){
            //   var packageList = result.result.map.subPackage
            //   packageList.forEach(item => {
            //     if(item.sendGoodMsg){
            //       item.sendGoodList = JSON.parse(item.sendGoodMsg)
            //     }else{
            //       item.sendGoodList = []
            //     }
            //     if(item.noSendGoodMsg){
            //       item.noSendGoodList = JSON.parse(item.noSendGoodMsg)
            //     }else{
            //       item.noSendGoodList = []
            //     }
            //   })
            // }


          }
        },
        function (err) {
          that.subListLoading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function (error) {
        that.subListLoading = false;
        console.log(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
  },
  data() {
    return {
      username: null,
      telephone: null,
      subListVisible: false,
      orderDetail: {},
      addLoading: false,
      loading: false,
      goodName: null,
      goodId: null,
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      subList: [],
      buList: [],
      subListLoading: false,
      dialogAddVisible: false,
      typeOptions: null,
      tableData: [],
      orderId: null
    };
  },
  mounted() { },
  methods: {
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    // print() {
    //   let that = this;
    //   let para = {
    //     token: localStorage.getItem("api_token"),
    //     id: that.orderId
    //   }
    //   API.h5_good_order_detail_print(para)
    //     .then(
    //       function (result) {
    //         if (result && parseInt(result.key) == 1000) {
    //           this.$message.success({
    //             showClose: true,
    //             message: "打印成功",
    //             duration: 1500
    //           });
    //         } else{
    //           that.$message.error({
    //             showClose: true,
    //             message: result.message,
    //             duration: 1500
    //           });
    //         }
    //       },
    //     )
    // }

  }
};
</script>

<style>
body {
  overflow: auto;
}

.fontWidth12 {
  width: 300px;
  display: inline-block;
  text-align: right;
}

.cont_navs_header1222 {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding-left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content_detail {
  background-color: #f2f2f2;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}

.contain_header {
  background-color: #fff;
  padding: 10px;
}

.cont_btns1 li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}

.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  margin-top: 10px;
  background-color: #f8f8f8;
}

.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}

.el-button+.el-button {
  margin-left: 0px !important;
}

.pri-div {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.pri-div>div {
  width: 48%;
  border: 1px solid #dadada;
  border-radius: 10px;
  margin-bottom: 20px;
}

.guii-list {
  padding: 0 10px 10px 10px;
}

.guide-name {
  margin-top: 10px;
  margin-bottom: 10px;
}

.item-value span {
  background-color: #bbb;
  display: inline-block;
  width: 100px;
  padding: 5px 10px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  text-align: center;
}

.guide-list>div {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.guide-list .el-input__inner {
  height: 27px;
  padding-right: 0px;
}

.guide-head {
  padding-top: 10px;
  background-color: #fafafa;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-bottom: 10px;
}

.userInfooi {
  flex: 1;
  display: block;
  height: auto;
}

.moreUserInfo11 ul {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.moreUserInfo11 li {
  color: #666;
  width: 33.3%;
}

.moreUserInfo11 .base_label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
}

.moreUserInfo11 ul li {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/orderDetailNew.vue